import isResultFromArchiveFanout from "./isResultFromArchiveFanout";
import type { ConversationType } from "owa-graph-schema";

/**
 * Whether the mailbox a search result's items live in is known with certainty.
 *
 * Archive-fanout results resolve their mailbox authoritatively from MailboxGuids, and results that
 * carry an explicit ConversationId.mailboxInfo are already scoped to the right store. Any other
 * search result falls back to the table's mailbox, which is a guess that can misroute a cross-store
 * id and make GetItem fail with ErrorInvalidIdMalformed, so its mailbox is not certain.
 */
export default function isSearchResultMailboxCertain(conversationType: ConversationType): boolean {
    if (conversationType?.MailboxGuids &&
        isResultFromArchiveFanout(conversationType.MailboxGuids)) {
        return true;
    }
    
    return !!conversationType.ConversationId?.mailboxInfo;
}
